export default __webpack_public_path__ + "static/media/trippy.8015dda6.glsl";